import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from '@/utils/icons';
import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'dls-peer dls-h-3.5 dls-w-3.5 dls-shrink-0 dls-rounded-none dls-border dls-border-border dls-bg-background focus-visible:dls-outline-none focus-visible:dls-ring-2 focus-visible:dls-ring-neutral focus-visible:dls-ring-offset-2 focus-visible:dls-ring-offset-background disabled:dls-cursor-not-allowed disabled:dls-opacity-50 data-[state=checked]:dls-bg-neutral data-[state=checked]:dls-text-white data-[state=indeterminate]:dls-bg-neutral data-[state=indeterminate]:dls-text-white',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('dls-flex dls-items-center dls-justify-center dls-text-current')}>
      {props.checked === 'indeterminate' ? (
        <Minus className="dls-h-3 dls-w-3" />
      ) : (
        <Check className="dls-h-3 dls-w-3" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
